<!-- TextAfterInput -->
<BI-grid-layout-item [row]="1" [col]="1" *ngIf="Control.TextAfterInput">
    <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
        <BI-grid-layout-item [row]="1" [col]="1">
            <ng-container *ngTemplateOutlet="textInput"></ng-container>
        </BI-grid-layout-item>

        <BI-grid-layout-item [row]="1" [col]="2">
            <span>{{ Control.TextAfterInput}} </span>
        </BI-grid-layout-item>
    </BI-grid-layout>
</BI-grid-layout-item>

<!-- TemplateRef -->
<BI-grid-layout-item [row]="1" [col]="1" *ngIf="Control.TemplateRef">
    <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
        <BI-grid-layout-item [row]="1" [col]="1">
            <ng-container *ngTemplateOutlet="textInput"></ng-container>
        </BI-grid-layout-item>

        <BI-grid-layout-item [row]="1" [col]="2">
            <ng-container [ngTemplateOutlet]="Control.TemplateRef">
            </ng-container>
        </BI-grid-layout-item>
    </BI-grid-layout>
</BI-grid-layout-item>

<!-- Input only -->
<BI-grid-layout-item [row]="1" [col]="1" *ngIf="!Control.TextAfterInput&&!Control.TemplateRef">
    <ng-container *ngTemplateOutlet="textInput"></ng-container>
</BI-grid-layout-item>

<!--  textInput-->
<ng-template #textInput>
    <mat-form-field [style]="Control.Style" appearance="outline">
        <mat-label>{{Control?.DisplayName ||"" | translate}}</mat-label>
        <textarea matInput [formControl]="FormControl" [id]="'input_'+Control.Name"></textarea>
        <validation-error-tool-tip matSuffix [FormControl]="FormControl" [Control]="Control">
        </validation-error-tool-tip>
    </mat-form-field>
</ng-template>